export const forecastContextOptionsQueryKeys = {
  all: ["forecastContextOptions"] as const,
  data: (options: Record<string, unknown>) =>
    [...forecastContextOptionsQueryKeys.all, { options }] as const
} as const;

export const forecastVersionsQueryKeys = {
  all: ["forecastVersions"] as const,
  data: () => [...forecastVersionsQueryKeys.all, "list"] as const
} as const;

export const forecastBudgetVersionsQueryKeys = {
  all: ["forecastBudgetVersions"] as const,
  data: (brand: string | null) =>
    [...forecastBudgetVersionsQueryKeys.all, { brand }] as const
} as const;

export const forecastAggLevelStatusQueryKeys = {
  all: ["forecastAggLevelStatus"] as const,
  data: (cubeId: string) =>
    [...forecastAggLevelStatusQueryKeys.all, { cubeId }] as const
} as const;

export const forecastContextSelectorQueryKeys = {
  all: ["forecastContextSelector"] as const,
  base: (cubeIds: string[]) =>
    [...forecastContextSelectorQueryKeys.all, "base", { cubeIds }] as const,
  list: (filters: string) =>
    [...forecastContextSelectorQueryKeys.all, { filters }] as const
} as const;

export const storeStatusQueryKeys = {
  all: ["storeStatusOptions"] as const
} as const;

export const eventChartDataQueryKeys = {
  all: ["eventChartData"] as const,
  data: () => [...eventChartDataQueryKeys.all] as const
} as const;

export const stackedChartQueryKeys = {
  all: ["stackedChart"] as const,
  data: (params: Record<string, unknown>) =>
    [...stackedChartQueryKeys.all, params] as const
} as const;

/** Query keys for the cube-years endpoint, shared across pages. */
export const cubeYearsQueryKeys = {
  all: ["cubeYears"] as const,
  byId: (cubeId: string) => [...cubeYearsQueryKeys.all, { cubeId }] as const
} as const;

/** Metadata query keys (mappings for grid columns / formats). */
export const forecastMetaDataQueryKeys = {
  all: ["forecastMetadata"] as const,
  data: () => [...forecastMetaDataQueryKeys.all] as const
} as const;

/** Forecast grid data query keys. */
export const forecastDataQueryKeys = {
  all: ["forecastData"] as const,
  data: (options: Record<string, unknown>) =>
    [...forecastDataQueryKeys.all, { options }] as const
} as const;

/** Query keys for the forecast-summary endpoint. */
export const forecastSummaryQueryKeys = {
  all: ["forecastSummary"] as const,
  data: (options: Record<string, unknown>) =>
    [...forecastSummaryQueryKeys.all, { options }] as const
} as const;
